import React, {Component} from 'react';
import PropTypes from 'prop-types';


export default class NavigationTabs extends Component {

	static propTypes = {
		newLabelsCount: PropTypes.number,
		updatedLabelsCount: PropTypes.number,
		notFoundLabelsCount: PropTypes.number,

	};

	render() {

		const {newLabelsCount, updatedLabelsCount, notFoundLabelsCount} = this.props;

		return (
			<div className="nav-tabs-navigation">
				<div className="nav-tabs-wrapper">
					<ul id="tabs" className="nav nav-tabs" role="tablist">
						<li className="nav-item">
							<a className="nav-link active" data-toggle="tab" href="#home" role="tab"
							   aria-expanded="true">New labels <span
								className="badge badge-pill badge-success">{newLabelsCount}</span></a>
						</li>
						<li className="nav-item">
							<a className="nav-link" data-toggle="tab" href="#profile" role="tab"
							   aria-expanded="false">Updated labels <span
								className="badge badge-pill badge-default">{updatedLabelsCount}</span></a>
						</li>
						<li className="nav-item">
							<a className="nav-link" data-toggle="tab" href="#messages" role="tab"
							   aria-expanded="false">Not found labels <span
								className="badge badge-pill badge-danger">{notFoundLabelsCount}</span></a>
						</li>
					</ul>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/NavigationTabs.js